var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:['main-container', _vm.showMenu ? 'block' : 'non-block']},[_c('header-component'),_c('router-view'),_c('footer-component'),_c('notification')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }